export default "__VITE_ASSET__cVLnZ8Y4__"